import React from 'react'
import Radio from '@material-ui/core/Radio'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import RadioGroup from '@material-ui/core/RadioGroup'
import { useController } from 'react-hook-form'
import { HelperText } from '.'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'
import classNames from 'classnames'

export const HookRadioGroup = (props) => {
  const {
    name,
    control,
    defaultValue = '',
    options,
    className,
    horizontal = false,
    color = 'secondary',
    children,
    onChange,
    disabled,
    ...rest
  } = props

  const {
    field,
    fieldState: { invalid, error }
  } = useController({
    name,
    control,
    defaultValue: defaultValue
  })

  function _onChange(e) {
    onChange?.(e)
    field.onChange(e)
  }

  return (
    <FormControl>
      <RadioGroup
        {...field}
        {...rest}
        onChange={_onChange}
        style={horizontal ? { display: 'inline-block' } : rest.style}
      >
        {options
          ? generateRadioButtons(options, className, color, disabled)
          : children}
      </RadioGroup>
      <HelperText invalid={invalid} error={error} />
    </FormControl>
  )
}

const generateRadioButtons = (options, className, color, disabled) => {
  return options.map((option, index) => {
    const _className = option.className
      ? option.className
      : className
      ? className
      : undefined
    return [
      <FormControlLabel
        value={option.value}
        label={option.label}
        disabled={option.disabled || disabled}
        classes={{ label: _className }}
        control={
          <Radio
            className={_className}
            color={color}
            icon={<RadioButtonUncheckedIcon fontSize="large" />}
            checkedIcon={
              <RadioButtonCheckedIcon
                fontSize="large"
                style={{ fill: disabled ? '#d3d3d3' : '#F67131' }}
              />
            }
          />
        }
        key={index}
      />,
      option.showOnSelect && option.showOnSelect.component ? (
        <div
          key={'d' + index}
          className={classNames(
            option.showOnSelect.condition ? 'visible' : 'invisible',
            option.showOnSelect.className
          )}
          style={option.showOnSelect.style}
        >
          {option.showOnSelect.component}
        </div>
      ) : null
    ]
  })
}

export const RadioButton = ({
  value,
  label,
  className,
  color = 'secondary',
  disabled = false
}) => {
  return (
    <FormControlLabel
      value={value}
      label={label}
      disabled={disabled}
      classes={{ label: className }}
      control={<Radio className={className} color={color} />}
    />
  )
}
